// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/article-page-news-intro/article-page-news-intro.component.scss
// module id = 438
// module chunks = 0